class BESSAppProjectEditorAPIService extends BESSAppAPIServiceBase {

    static instance() {
        return BESSApp.instance.services.api.project.editor;
    }

    constructor(parent) {
        super(parent, 'editor/');
    }

    apiSave(editorData, onSaved, onError = null) {
        this._post('save', {
            data: editorData,
            onResult: onSaved,
            onError: onError,
        });
    }

    apiNewProject(editorData, onSaved, onError = null) {
        this._post('new-project', {
            data: editorData,
            onResult: onSaved,
            onError: onError,
        });
    }

    apiUpdate(editorData, onSaved, onError = null) {
        this._post('update', {
            data: editorData,
            onResult: onSaved,
            onError: onError,
        });
    }

    apiRemove(editorId, itemNo, onSaved, onError = null) {
        this._post('remove', {
            data: {
                'editor_id': editorId,
                'item_no': itemNo,
            },
            onResult: onSaved,
            onError: onError,
        });
    }
}